import { render, staticRenderFns } from "./EmptyItems.vue?vue&type=template&id=1569b8ce&scoped=true"
import script from "./EmptyItems.vue?vue&type=script&lang=js"
export * from "./EmptyItems.vue?vue&type=script&lang=js"
import style0 from "./EmptyItems.vue?vue&type=style&index=0&id=1569b8ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1569b8ce",
  null
  
)

export default component.exports